export default {
  mfname: 'List of Authorized Cooperative Manufacturers',
  mfmission:
    'We have established long-term and in-depth cooperative partnerships with all the manufacturers listed below, with solid relationship endorsements. This list serves as a fundamental basis for factory inspections and cooperative partner screening, fully demonstrating our strong and reliable supply chain capacity.',
  mf_categoryList: [
    {
      category: 'Air Conditioning Category',
      manufacturers: ['Envicool', 'Haiwu', 'Climaveneta', 'Canatal'],
    },
    {
      category: 'Plate Heat Exchanger Category',
      manufacturers: ['APV', 'Tranter', 'Danfoss'],
    },
    {
      category: 'Cooling Tower Category',
      manufacturers: ['Marley', 'BAC', 'EMIG'],
    },
    {
      category: 'Water Pump Category',
      manufacturers: ['Wilo', 'Xylem', 'Grundfos', 'Ebara'],
    },
    {
      category: 'Chiller Category',
      manufacturers: ['York', 'Trane', 'Carrier', 'McQuay'],
    },
    {
      category: 'CDU (Cooling Distribution Unit) Category',
      manufacturers: ['Envicool', 'Sugon', 'Gaolan'],
    },
    {
      category: 'Water Treatment Category',
      manufacturers: ['Kurita', 'Nalco', 'Jieyutong'],
    },
    {
      category: 'BA System (Building Automation System) Category',
      manufacturers: ['Johnson Controls', 'Siemens'],
    },
    {
      category: 'Transformer Category',
      manufacturers: ['Jinpan', 'Daqo', 'TBEA'],
    },
    {
      category: 'Power Distribution Cabinet Category',
      manufacturers: ['ABB', 'Schneider Electric', 'Eaton', 'Siemens'],
    },
    {
      category: 'PDU (Power Distribution Unit) Category',
      manufacturers: ['Legrand', 'Claymore', 'Eaton', 'Top'],
    },
    {
      category: 'UPS (Uninterruptible Power Supply) Category',
      manufacturers: ['Schneider Electric', 'Eaton', 'Delta'],
    },
    {
      category: 'Battery Category',
      manufacturers: ['Narada', 'Shuangdeng', 'Leoch', 'Saint-Sun', 'C&D'],
    },
    {
      category: 'Busway Category',
      manufacturers: ['Schneider Electric', 'ABB', 'Siemens', 'Eaton'],
    },
    {
      category: 'Diesel Generator Category',
      manufacturers: [
        'Caterpillar',
        'Cummins',
        'MTU',
        'Pangu',
        'Yuchai',
        'Weichai',
      ],
    },
    {
      category: 'Dynamic Environment Monitoring Category',
      manufacturers: ['Yingze Tiancheng', 'Shenzhen CEC'],
    },
  ],
};
